import { render, staticRenderFns } from "./BannersComponent.vue?vue&type=template&id=74e74eb8&scoped=true&lang=html&"
import script from "./BannersComponent.vue?vue&type=script&lang=js&"
export * from "./BannersComponent.vue?vue&type=script&lang=js&"
import style0 from "./BannersComponent.vue?vue&type=style&index=0&id=74e74eb8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e74eb8",
  null
  
)

export default component.exports